<script lang="ts">
  import TBody from "../atoms/TBody.svelte";
  import THead from "../atoms/THead.svelte";
  import { ErrorService } from "../services/error.service";

  export let klass = "";
  export let headers = [];
  export let items = [];
  export let rows = [];
  export let asLink = false;

  export let selectRow: Function = () => {
    ErrorService.unimplemented();
  };
</script>

<div class="block overflow-x-scroll whitespace-nowrap w-full">
  <table class="table-fixed w-full {klass}">
    <THead {headers} />
    <TBody {items} {rows} {asLink} klass="mt-2" {selectRow} />
  </table>
</div>
